import React, { useCallback } from "react";
import { useScrollTrigger, Fab } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const ScrollToTop = ({ threshold = 100 }) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: threshold,
  });

  const handleClick = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    trigger && (
      <Fab
        color="secondary"
        size="small"
        onClick={handleClick}
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
        }}
      >
        <ArrowUpwardIcon />
      </Fab>
    )
  );
};

export default ScrollToTop;
